import { Component, OnInit } from '@angular/core';

import { ModalService } from '@app/core/services/modal.service';
import {
    ChoicePossRulesItem,
    ChoicePossRulesRunGet,
    ChoicePossRulesService,
    ModelItem,
    ProductChoiceItem,
} from '@app/services/choice-poss-rules.service';

@Component({
    selector: 'tt-choice-poss-rules-run',
    templateUrl: './choice-poss-rules-run.component.html',
    styleUrls: ['./choice-poss-rules-run.component.css'],
    standalone: false,
})
export class ChoicePossRulesRunComponent implements OnInit {
    public page?: ChoicePossRulesRunGet;

    public selectListProductChoices: ProductChoiceItem[] = [];

    public selectListModels: ModelItem[] = [];

    public itemsListCounts: ChoicePossRulesItem[] = [];

    public itemsListProducts: ChoicePossRulesItem[] = [];

    public selectedView: 'COUNT' | 'PRODUCTS' = 'COUNT';

    public executing = false;

    constructor(
        private choicePossRules: ChoicePossRulesService,
        private modal: ModalService,
    ) {}

    public async onPageChanged(value: string, field: 'choice_prod_id' | 'model_id'): Promise<void> {
        if (!this.page || !value) return;

        this.page[field] = value;
        await this.loadLists();
    }

    public async execute(): Promise<void> {
        if (!this.page || this.itemsListProducts.length === 0) return;

        const products = this.itemsListProducts.filter((item) => item.item_id !== '0' && item.item_id !== '9999');
        if (products.length === 0) return;

        this.executing = true;
        const progress = this.modal.openProgressDialog({ value: 0, max: products.length, label: 'progressbar', finishclose: true });

        try {
            for (const product of products) {
                if (progress.data.status === 'cancelled') break;

                await this.choicePossRules.executeRule({ ...this.page, prod_id: product.item_id });
                progress.updateValue(progress.data.value + 1);
            }

            if (progress.data.status !== 'cancelled') progress.updateStatus('finish');
        } catch (error) {
            progress.updateStatus('invalid');
            progress.updateInvalidText(error instanceof Error ? error.message : '');
        } finally {
            this.executing = false;
            await this.loadProducts();
        }
    }

    private async init(): Promise<void> {
        await Promise.all([this.loadProductChoices(), this.loadModels()]);
        this.page = await this.choicePossRules.getRunPage();
        await this.loadLists();
    }

    private async loadProductChoices(): Promise<void> {
        this.selectListProductChoices = await this.choicePossRules.listProductChoices({ add_all: '1' });
    }

    private async loadModels(): Promise<void> {
        this.selectListModels = await this.choicePossRules.listModels({ add_all: '1', show_inactive: '0' });
    }

    private async loadLists(): Promise<void> {
        await Promise.all([this.loadCounts(), this.loadProducts()]);
    }

    private async loadCounts(): Promise<void> {
        if (!this.page || !this.hasPageFilters()) {
            this.itemsListCounts = [];
            return;
        }

        this.itemsListCounts = await this.choicePossRules.listCounts(this.page);
    }

    private async loadProducts(): Promise<void> {
        if (!this.page || !this.hasPageFilters()) {
            this.itemsListProducts = [];
            return;
        }

        this.itemsListProducts = await this.choicePossRules.listProducts(this.page);
    }

    private hasPageFilters(): boolean {
        return !!this.page?.choice_prod_id?.trim() && !!this.page?.model_id?.trim();
    }

    ngOnInit(): void {
        void this.init();
    }
}
